export function arrayToCsv(data) {
  return data.map(row =>
    row
    .map(String)
    .map(v => v.replaceAll('"', '""'))
    .join(';')
  ).join('\r\n');
}

export function downloadBase64File(fileBase64: string, fileName: string) {
  const dataURI = "data:aplication/plain;base64," + (fileBase64);
  var a = document.createElement("a");
  a.href = dataURI;
  a.setAttribute("download", fileName);
  a.click();
}
